import { Injectable } from '@angular/core';
import { ServiceManagerBase } from '../common/service-manager-base';
import { BroadcastService } from '../../core/services/broadcast.service';
import { Product } from './product.model';
import { Observable, of } from 'rxjs';
import { TenantApiService } from './tenant-api.service';
import { tap } from 'rxjs/operators';
import { Tenant } from './tenant.model';

@Injectable({
	providedIn: 'root'
})
export class TenantManagerService extends ServiceManagerBase
{
	private _currentProduct?: Product;

	constructor(broadcastService: BroadcastService,
	            private tenantApiService: TenantApiService)
	{
		super(broadcastService);
	}

	switchingOrganizations()
	{
		this._currentProduct = undefined;
	}

	protected clearCache()
	{
		if (this.retrievingData) return;
		this._currentProduct = undefined;
	}

	getAllTenants(): Observable<Tenant[]>
	{
		return this.tenantApiService.getAllTenants();
	}

	getAllProducts(): Observable<Product[]>
	{
		return this.tenantApiService.getAllProducts();
	}

	get currentProduct(): Observable<Product>
	{
		if (this._currentProduct)
		{
			return of(this._currentProduct);
		}

		this.retrievingData = true;
		return this.tenantApiService.getProduct().pipe(tap(product => {
			this._currentProduct = product;
			this.retrievingData = false;
		}));
	}
}
